export enum ChangePasswordFormFields {
  OldPassword = 'oldPassword',
  NewPassword = 'newPassword',
  ConfirmNewPassword = 'confirmNewPassword',
}
